import { api } from './client';
import type { DialogDto, DialogListFilters, MessageDto, Page } from './types';

export function listDialogs(filters: DialogListFilters): Promise<Page<DialogDto>> {
  return api.get<Page<DialogDto>>('/api/v1/dialogs', filters as Record<string, string | number | boolean | undefined>);
}

export function getDialog(id: string): Promise<DialogDto> {
  return api.get<DialogDto>(`/api/v1/dialogs/${id}`);
}

export function listMessages(id: string, cursor?: string): Promise<Page<MessageDto>> {
  return api.get<Page<MessageDto>>(`/api/v1/dialogs/${id}/messages`, { cursor });
}

export function handoff(id: string, to: 'human' | 'agent', mode?: 'continue' | 'close'): Promise<DialogDto> {
  return api.post<DialogDto>(`/api/v1/dialogs/${id}/handoff`, { to, mode });
}

export function closeDialog(id: string): Promise<DialogDto> {
  return api.post<DialogDto>(`/api/v1/dialogs/${id}/close`, {});
}

export function sendMessage(id: string, text: string): Promise<MessageDto> {
  return api.post<MessageDto>(`/api/v1/dialogs/${id}/messages`, { text });
}

export interface ObservedMessageInput {
  dialog_id?: string;
  channel_id?: string;
  vk_user_id?: number;
  text: string;
  sent_at: string;
}

export function recordObservedMessage(input: ObservedMessageInput): Promise<MessageDto> {
  return api.post<MessageDto>('/api/v1/messages/observed', input);
}
